import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeDocsExampleModule } from 'se-fe-docs-example'
import { SeFeDocsTableModule } from 'se-fe-docs-table'
import { SeFeHeaderModule } from 'se-fe-header'
import { SeFePageModule } from 'se-fe-page'
import { SharedUiPersonaPickerModule } from '../lib/shared-ui-persona-picker.module'
import { PersonaPickerDocsComponent } from './persona-picker-docs/persona-picker-docs.component'
import { PersonaPickerExampleComponent } from './persona-picker-docs/persona-picker-example.component'

@NgModule({
  imports: [
    CommonModule,
    SeFeCardModule,
    SeFeDocsExampleModule,
    SeFeDocsTableModule,
    SeFeHeaderModule,
    SeFePageModule,
    SharedUiPersonaPickerModule
  ],
  declarations: [
    PersonaPickerDocsComponent,
    PersonaPickerExampleComponent
  ],
  exports: [PersonaPickerDocsComponent],
})
export class SharedUiPersonaPickerDocsModule {}
